<template>
    <div>
        <app-sub-title text="Subtipos de herramienta" />
        <button class="btn btn-primary" @click="startCreateSubType">
            <i class="fa fa-plus"></i> Crear subtipo de herramienta
        </button>

        <app-item-sub-types-filters @filter="onFilter" :item-types="itemTypes" />
        <app-item-sub-types-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            :on-delete="startDeleteSubType"
            @sort="onSort"
        />

        <!-- PopUps -->
        <app-pop-up
            id="item-sub-type-form"
            title="Formulario subtipo de herramienta"
            :on-close="cleanForm"
        >
            <div slot="body">
                <app-item-sub-type-form
                    :my-sub-type="itemSubType"
                    @updated="onUpdated"
                    @created="onSave"
                />
            </div>
            <div slot="buttons">
                <button class="btn btn-primary" :disabled="inProgress" @click="saveSubTypeItem">
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="item-type-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar este subtipo de herramienta?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteSubType(itemSubType)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import itemsRepository from '../../../repositories/items.repository'
import PopUp from '../../UI/Controls/PopUp/PopUp.vue'
import ItemSubTypeForm from './ItemSubTypeForm/ItemSubTypeForm.vue'
import SubTitle from '../../UI/Layout/SubTitle.vue'
import ItemSubTypesList from './ItemSubTypesList/ItemSubTypesList.vue'
import ItemSubTypesFilters from './ItemSubTypesFilters/ItemSubTypesFilters.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        appPopUp: PopUp,
        appItemSubTypeForm: ItemSubTypeForm,
        appSubTitle: SubTitle,
        appItemSubTypesList: ItemSubTypesList,
        appItemSubTypesFilters: ItemSubTypesFilters,
    },

    data() {
        return {
            data: [],
            page: 1,
            itemSubType: '',
            sort: {
                sortBy: 'name',
                sortDir: 'asc',
            },
            filters: null,
        }
    },
    computed: {
        ...mapGetters(['itemTypes']),
    },
    methods: {
        async loadSubTypes() {
            try {
                const params = {
                    page: this.page,
                    sortBy: this.sort.sortBy,
                    sortDir: this.sort.sortDir,
                    ...this.filters,
                }
                const { data } = await repo.get('item-sub-types', params)
                this.data = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onFilter(filters) {
            console.log(filters)
            this.filters = filters
            this.loadSubTypes()
        },
        onChangePage(page) {
            this.page = page
            this.loadSubTypes()
        },
        onEdit(itemSubType) {
            this.itemSubType = Object.assign({}, itemSubType)
            this.$bus.$emit('item-sub-type-form.open')
        },
        async deleteSubType(itemSubType) {
            const { data } = await repo.delete(
                `item-sub-types/${itemSubType.id}`
            )
            if (!!data.status) {
                this.loadSubTypes()
                this.$bus.$emit('item-type-remove.close')
                toastr.success(data.msg)
            } else {
                toastr.error(data.msg)
            }
        },
        startDeleteSubType(itemSubType) {
            this.itemSubType = itemSubType
            this.$bus.$emit('item-type-remove.open')
        },
        startCreateSubType() {
            this.itemSubType = ''
            this.$bus.$emit('item-sub-type-form.open')
        },
        saveSubTypeItem() {
            this.$bus.$emit('item-sub-type-form.save')
        },
        onSave() {
            this.$bus.$emit('item-sub-type-form.close')
            this.loadSubTypes()
        },
        cleanForm() {
            this.$bus.$emit('item-sub-type-form.clean')
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadSubTypes()
        },
        onUpdated() {
            this.$bus.$emit('item-sub-type-form.close')
            this.loadSubTypes()
        },
    },

    created() {
        this.loadSubTypes()
        this.load('itemTypes')
    },
}
</script>
